import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Form,
  Alert,
  Spinner,
  InputGroup,
  DropdownDivider,
} from "react-bootstrap";

import GeneralForm from "./GeneralForm";
import ShippingDetails from "./ShippingDetails";
import Stepper from "../../components/Stepper";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import moment from "moment";
import {
  IconArrowNarrowLeftDashed,
  IconArrowNarrowRightDashed,
} from "@tabler/icons-react";
import { useForm, FormProvider, useFormContext } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS, roundToMoney } from "../../constant/_constant";
import { toast } from "react-toastify";
import { format } from "date-fns";
import SuccsessMsgModal from "../../components/SuccessMsgModal";
import { isValidPhoneNumber } from "react-phone-number-input";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ProductDetails from "./ProductDetails";
import FileUpload from "../../components/Attachment/Attachment";
import NotesSection from "./NotesSection";
import InvestigationForm from "./InvestigationForm";
import ResolutionForm from "./ResolutionForm";
import FollowupForm from "./FollowupForm";
import CreateRma from "./CreateRma";
import useIdleLogout from "../../hooks/useIdleLogout";

const generateUniqueId = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  let result = "";
  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  const timestamp = Date.now().toString();
  const uniqueId = result + timestamp.slice(-4);
  return uniqueId;
};

const PORT = process.env.REACT_APP_BASE_URL;

function UpdateRma() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [initialVal, setInitialVal] = useState(1);
  const [serverErr, setServerErr] = useState([]);
  const [show, setShow] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [rmaDataFetched, setRmaDataFetched] = useState(false);
  const [orderData, setOrderData] = useState([]);
  const [rfqDataFetchedcopy, setRfqDataFetchedcopy] = useState(false);
  const [formId, setFormId] = useState(null);
  const [singleRmaQuantity, setSingleRmaQuantity] = useState([]);
  const [rmaSuccess, setRmaSuccess] = useState(null);
  const [searchDebounce, setSearchDebounce] = useState({
    searchName: "",
    searchEmail: "",
  });
  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    message: "",
    btntext: "",
    title: "",
  });

  console.log("singleRmaQuantity", singleRmaQuantity);
  const [rfqstatus, setRfqStatus] = useState();

  const handleStatusChange = (event) => {
    setRfqStatus(event.target.value);
  };

  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const { rma_id } = useParams();

  const schema = yup.object().shape({
    notes: yup.array().of(
      yup.object().shape({
        section: yup.string().required("Section is required"),
        notesdata: yup.array().of(
          yup.object().shape({
            note: yup.string().required("Note cannot be blank"),
          }),
        ),
      }),
    ),

    // step 1
    rma_id: yup.string().required("RMA ID is required"),
    manufacturer_id: yup.string().nullable(),
    publishedDate: yup.date().required("Published Date is required"),
    // estimatedDate: yup.date().required("Estimated Return Date is required"),
    actualDate: yup.date().required("Actual Return Date is required"),
    // actualDate: yup.date().optional(),
    orderId: yup.string().optional(),
    initialCause: yup.string().optional(""),
    purchaseOrder: yup.string().optional(""),
    organization_name: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable()
      .min(2, "Must be at least 2 character")
      .max(100, "Must be at most 100 characters"),

    rma_Description: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable()
      .min(5, "Must be at least 5 characters")
      .max(500, "Must be at most 500 characters"),

    // step 2
    // trackingID: yup.string().nullable(),
    trackingID: yup
      .string()
      .nullable()
      .test(
        "minLength",
        "Tracking ID must be at least 5 characters",
        function (value) {
          if (value === null || value === undefined || value === "")
            return true;
          return typeof value === "string" && value.length >= 5;
        },
      ),

    // trackingID: yup
    //   .string()
    //   .nullable()
    //   .test(
    //     "minLength",
    //     "Tracking ID must be at least 5 characters",
    //     function (value) {
    //       if (value === null || value === "") return true; // Allow nullable or empty
    //       return value.length >= 5;
    //     }
    //   ),
    shipping_method: yup.string().optional(),
    shipping_method_detail: yup.string().optional(),
    contractOfficerName: yup.string().optional(),
    contractOfficerEmail: yup
      .string()
      .optional()
      .email("Email must be a valid email address"),
    contractOfficerPhone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable()
      .test("valid-phone", "Invalid phone number", (value) => {
        if (!value) {
          return true;
        }
        if (typeof value === "string" && value.trim() !== "") {
          return isValidPhoneNumber(value);
        }

        return false;
      })
      .optional(),
    contractOfficerAddress: yup.string().optional(),

    shippingCustomerName: yup.string().optional(),
    shippingCustomerEmail: yup
      .string()
      .optional()
      .email("Email must be a valid email address"),
    shippingCustomerPhone: yup
      .string()
      .transform((value) => (value === "" ? null : value))
      .nullable()
      .test("valid-phone", "Invalid phone number", (value) => {
        if (!value) {
          return true;
        }
        if (typeof value === "string" && value.trim() !== "") {
          return isValidPhoneNumber(value);
        }
        return false;
      })
      .optional(),
    shippingCustomerAddress: yup.string().optional(),

    // products: yup.array().of(
    //   yup.object().shape({
    //     refund_qty: yup
    //       .number()
    //       .transform((value) => (value === "" ? undefined : value))
    //       .typeError("Return quantity is required.")
    //       .required("Return quantity is required.")
    //       .min(1, "Return quantity must be greater than 0.")
    //       .test(
    //         "refund-less-than-qty",
    //         "Return quantity cannot exceed quantity.",
    //         function (refund_qty) {
    //           const { qty } = this.parent;
    //           return refund_qty <= qty;
    //         }
    //       ),
    //   })
    // ),

    // qty: yup.string().required("Quantity is required."),

    // qty: yup
    //   .number()
    //   .transform((value) => (value === "" ? null : value))
    //   .typeError("Must be a number.")
    //   .required("Quantity is required.")
    //   .test("is-valid-number", "not nagetive.", (value) => {
    //     return value === null || (!isNaN(value) && value !== -1);
    //   })
    //   .min(1, "at least 1."),
  });

  const transformData = (resData) => {
    return {
      notes: resData.map((section) => ({
        section: section.name,
        custom_id: section.custom_id,
        notesdata: section.notes.map((noteItem) => ({
          note: noteItem.note,
          user: noteItem.User?.username || "CUSTOMER",
          updateAt: noteItem.updated_at,
          custom_id: noteItem.custom_id || undefined,
        })),
      })),
    };
  };

  const onSingleNotesSuccess = (res) => {
    if (res?.data) {
      const transformedData = transformData(res.data);
      setValue("notes", transformedData.notes);
    }
  };

  useIdleLogout();

  const onOrderIdError = (err) => {
    reset({
      OrderID: getValues("orderId"),
    });
    console.log("error", err);
    toast.error("The order with this Order ID does not exist.");
    setValue("orderId", "");
  };

  const onOrderIdSuccess = (res) => {
    if (res?.data) {
      if (
        res?.data?.status !== "DELIVERED" &&
        res?.data?.status !== "PAID_CLOSED"
      ) {
        toast.error(
          "The order with this Order ID is either not yet completed or does not exist.",
        );
        setValue("orderId", "");
        setValue("trackingID", "");
        setValue("rmaType", "");
        setValue("manufacturer_id", null);
        setValue("organization_name", "");
        setValue("estimatedDate", null);
        setValue("actualDate", null);
        setValue("rma_Description", "");
        return;
      }
      setValue("orderId", res?.data?.order_id ? res?.data?.order_id : null);
      // setValue("rma_id", res?.data?.rma_id ? res?.data?.rma_id : null);
      setValue(
        "trackingID",
        res?.data?.tracking_number ? res?.data?.tracking_number : null,
      );
      setValue("rmaType", res?.data?.rma_type ? res?.data?.rma_type : "");
      setValue(
        "manufacturer_id",
        res?.data?.manufacturer_id ? res?.data?.manufacturer_id : null,
      );
      setValue(
        "organization_name",
        res?.data?.organization_name ? res?.data?.organization_name : "",
      );
      setValue(
        "estimatedDate",
        res?.data?.estimated_date
          ? moment(res?.data?.estimated_date).format("MM/DD/YYYY")
          : null,
      );
      setValue(
        "actualDate",
        res?.data?.actual_date
          ? moment(res?.data?.actual_date).format("MM/DD/YYYY")
          : null,
      );
      setValue("rma_Description", res?.data?.brief);

      setValue(
        "shipping_method",
        res?.data?.shipping_method ? res?.data?.shipping_method : "",
      );
      setValue(
        "shipping_method_detail",
        res?.data?.shipping_method_detail
          ? res?.data?.shipping_method_detail
          : "",
      );
      setValue(
        "contractOfficerName",
        res?.data?.orderKo?.name ? res?.data?.orderKo?.name : "",
      );
      setValue(
        "contractOfficerEmail",
        res?.data?.orderKo?.email ? res?.data?.orderKo?.email : "",
      );
      setValue(
        "contractOfficerPhone",
        res?.data?.orderKo?.phone ? res?.data?.orderKo?.phone : "",
      );
      setValue(
        "contractOfficerAddress",
        res?.data?.orderKo?.address ? res?.data?.orderKo?.address : "",
      );

      setValue(
        "shippingCustomerName",
        res?.data?.orderShipping?.name ? res?.data?.orderShipping?.name : "",
      );
      setValue(
        "shippingCustomerPhone",
        res?.data?.orderShipping?.phone ? res?.data?.orderShipping?.phone : "",
      );
      setValue(
        "shippingCustomerEmail",
        res?.data?.orderShipping?.email ? res?.data?.orderShipping?.email : "",
      );
      setValue(
        "shippingCustomerAddress",
        res?.data?.orderShipping?.address
          ? res?.data?.orderShipping?.address
          : "",
      );
      // setValue("qty", res?.data?.OrderProductSales?.[0]?.quantity || 0);
      // setValue(
      //   "vendorName",
      //   res?.data?.OrderProductSales?.[0]?.Vendor?.display_name || ""
      // );
      setValue(
        "sameShipNameasKO",
        res?.data?.is_shipping_same_ko ? res?.data?.is_shipping_same_ko : "",
      );
      // setValue("invoice_no", res?.data?.OrderProducts?.[0]?.sku_id || "");
      // setValue("prod_desc", res?.data?.OrderProducts?.[0]?.description || "");
      // setValue("sku_price", res?.data?.OrderProducts?.[0]?.total_price || "");
      res?.data?.OrderProductSales?.forEach((product, index) => {
        setValue(
          `products[${index}].vendorName`,
          product?.Vendor?.display_name || "",
        );
        setValue(`products[${index}].invoice_no`, product?.sku_id || "");
        setValue(`products[${index}].prod_desc`, product?.description || "");
        setValue(`products[${index}].qty`, product?.quantity || "");
        setValue(`products[${index}].sku_price`, product?.total_price || "");
        setValue(`products[${index}].autoId`, product?.auto_id || "");
      });
      // setAutoId(
      //   res?.data?.OrderProducts?.map((product) => product?.auto_id || "")
      // );
      setValue(
        "totalCostBeforeMargin",
        res?.data?.total_cost_before_margin
          ? res?.data?.total_cost_before_margin
          : null,
      );
      setValue(
        "totalCostAfterMargin",
        res?.data?.total_cost_after_margin
          ? res?.data?.total_cost_after_margin
          : null,
      );
    }
  };

  const onOrderIdSuccessRma = (res) => {
    setOrderData(res?.data);
  };

  const { data: rma, postData: fetchSingleRma } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_RMA,
  );

  const { data: notesData, postData: fetchNotes } = usePostRequest(
    API_ENDPOINTS.GET_NOTES,
  );

  const { data: databyOrderId, postData: fetchDataByOrderID } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_ORDER,
  );

  const steps = [
    "RMA Created",
    "Investigation",
    "Resolution",
    "Follow Up",
    "Attachments",
    "Notes",
  ];

  const onSingleRmaSuccess = (res) => {
    if (res?.data) {
      setRmaSuccess(res?.data);
      setValue("orderId", res?.data?.order_id ? res?.data?.order_id : "");
      setValue("rma_id", res?.data?.rma_id ? res?.data?.rma_id : null);
      setValue(
        "manufacturer_id",
        res?.data?.manufacturer_id ? res?.data?.manufacturer_id : null,
      );
      setValue("rmaType", res?.data?.rma_type ? res?.data?.rma_type : "");
      setValue("purchaseOrder", res?.data?.purchase_order || "");
      setValue("initialCause", res?.data?.initial_cause || "");
      setValue(
        "organization_name",
        res?.data?.organization_name ? res?.data?.organization_name : "",
      );
      setValue("custom_fields", res?.data?.custom_fields || []);
      setValue("rma_Description", res?.data?.brief);
      setValue(
        "publishedDate",
        res?.data?.published_date
          ? moment(res?.data?.published_date).format("MM/DD/YYYY")
          : null,
      );
      setValue(
        "actualDate",
        res?.data?.actual_date
          ? moment(res?.data?.actual_date).format("MM/DD/YYYY")
          : null,
      );
      setValue(
        "estimatedDate",
        res?.data?.estimated_date
          ? moment(res?.data?.estimated_date).format("MM/DD/YYYY")
          : null,
      );
      setValue(
        "estimateddelivery",
        res?.data?.estimated_delivery ? res?.data?.estimated_delivery : "",
      );
      setValue(
        "payment_terms",
        res?.data?.payment_term ? res?.data?.payment_term : "",
      );
      if (res?.data?.attachment_id) {
        setFormId(res?.data?.attachment_id);
      }
      setValue(
        "shipping_method",
        res?.data?.shipping_method ? res?.data?.shipping_method : "",
      );
      setValue(
        "shipping_method_detail",
        res?.data?.shipping_method_detail
          ? res?.data?.shipping_method_detail
          : "",
      );
      setValue(
        "shipping_terms",
        res?.data?.shipping_term ? res?.data?.shipping_term : "",
      );
      setValue(
        "contractOfficerName",
        res?.data?.rmaKo?.name ? res?.data?.rmaKo?.name : "",
      );
      setValue(
        "contractOfficerEmail",
        res?.data?.rmaKo?.email ? res?.data?.rmaKo?.email : "",
      );
      setValue(
        "contractOfficerPhone",
        res?.data?.rmaKo?.phone ? res?.data?.rmaKo?.phone : "",
      );
      setValue(
        "contractOfficerAddress",
        res?.data?.rmaKo?.address ? res?.data?.rmaKo?.address : "",
      );
      setValue(
        "sameShipNameasKO",
        res?.data?.is_shipping_same_ko ? res?.data?.is_shipping_same_ko : "",
      );
      setValue(
        "shippingCustomerName",
        res?.data?.rmaShipping?.name ? res?.data?.rmaShipping?.name : "",
      );
      setValue(
        "shippingCustomerEmail",
        res?.data?.rmaShipping?.email ? res?.data?.rmaShipping?.email : "",
      );
      setValue(
        "shippingCustomerPhone",
        res?.data?.rmaShipping?.phone ? res?.data?.rmaShipping?.phone : "",
      );
      setValue(
        "shippingCustomerAddress",
        res?.data?.rmaShipping?.address ? res?.data?.rmaShipping?.address : "",
      );

      setSingleRmaQuantity(res?.data?.RmaProducts || []);

      setValue(
        "rma_Finding",
        res?.data?.RmaInvestigation?.investigation_finding
          ? res?.data?.RmaInvestigation?.investigation_finding
          : "",
      );

      // setValue(
      //   "totalCostAfterMargin",
      //   res?.data?.total_cost_after_margin
      //     ? res?.data?.total_cost_after_margin
      //     : null
      // );
      // setValue(
      //   "totalCostBeforeMargin",
      //   res?.data?.total_cost_before_margin
      //     ? res?.data?.total_cost_before_margin
      //     : null
      // );
      setInitialVal(0);

      // fetchDataByOrderID(
      //   { order_id: res?.data?.order_id },
      //   onOrderIdSuccessRma
      // );
    }
  };

  const [currentStep, setCurrentStep] = useState(1);

  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      // shippingCostEnabled: true,
      // taxEnabled: true,
      // tax: parseFloat("0.00").toFixed(2),
      // shippingCost: parseFloat("0.00").toFixed(2),
      // sales_lead_email: ,
      // sales_lead_name : ,
      // sales_lead_phone: ,
    },
  });

  const {
    handleSubmit,
    setError,
    reset,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = methods;

  console.log("errors", errors);

  const onError = (error) => {
    if (error?.errors) {
      const updatedErrors = {};
      Object.keys(error.errors).forEach((field) => {
        if (error.errors[field]?.message) {
          updatedErrors[field] = {
            message: error.errors[field]?.message,
          };
        }
      });

      setServerErr((prevState) => ({
        ...prevState,
        ...updatedErrors,
      }));
      setShow(true);
    }
    toast.error(error?.message);
  };

  const { isLoading: createLoading, postData: createRMA } = usePostRequest(
    API_ENDPOINTS.CREATE_RMA,
  );

  const { isLoading: notesLoading, postData: createNotes } = usePostRequest(
    API_ENDPOINTS.CREATE_NOTES,
  );

  const { isLoading: UpdateLoading, postData: updateRMA } = usePostRequest(
    API_ENDPOINTS.UPDATE_RMA,
  );

  const onSubmit = (data) => {
    const isUpdate = rma && rma_id;

    const custom_fieldsTransformed = data?.custom_fields?.map((fields) => {
      if (fields?.type === "Date") {
        return {
          type: fields?.type,
          value: moment(fields?.value).format("YYYY-MM-DD"),
          field_name: fields?.field_name,
        };
      } else {
        return {
          type: fields?.type,
          value: fields?.value,
          field_name: fields?.field_name,
        };
      }
    });

    // const transformedProducts = data?.products
    //   ?.filter(
    //     (product) => product?.refund_qty !== null && product?.refund_qty !== ""
    //   )
    //   .map((product) => ({
    //     vendor_name: product?.vendorName || null,
    //     sku_id: product?.invoice_no || null,
    //     description: product?.prod_desc || null,
    //     quantity: product?.qty ? Number(product?.qty) : 0,
    //     total_price: product?.sku_price ? Number(product?.sku_price) : 0,
    //     return_quantity: Number(product?.refund_qty),
    //   }));

    // console.log("the res is ", singleRmaQuantity);

    const transformedProducts = data?.products?.map((product) => {
      const qty = Number(product?.qty || 0);
      const customerPrice = Number(product?.sku_price || 0);

      return {
        auto_id: product?.autoId ? product?.autoId : null,
        is_return: product?.is_selected ? true : false,
        vendor_name: product?.vendorName ? product?.vendorName : null,
        name: product?.name ? product?.name : null,
        sku_id: product?.sku_main ? product?.sku_main : null,
        sku_display_name: product?.invoice_no ? product?.invoice_no : null,
        description: product?.prod_desc?.trim() ? product.prod_desc : null,
        quantity: product?.qty ? Number(product?.qty) : 0,
        max_quantity: product?.mainQty ? Number(product?.mainQty) : 0,
        customer_price: product?.sku_price ? Number(product?.sku_price) : 0,
        raw_sku_id: product?.row_id ? product?.row_id : null,
        total_price: roundToMoney(qty * customerPrice),
      };
    });

    const payload = {
      rma_id: data?.rma_id ? data?.rma_id : null,
      manufacturer_id: data?.manufacturer_id ? data?.manufacturer_id : null,
      rma_type: data?.rmaType ? data?.rmaType : null,
      order_id: data?.orderId ? data?.orderId : null,
      initial_cause: data?.initialCause ? data?.initialCause : null,
      purchase_order: data?.purchaseOrder ? data?.purchaseOrder : null,
      // purchase_order: data?.purchaseOrder ? data?.purchaseOrder : null,
      // initial_cause: data?.initialCause ? data?.initialCause : null,
      published_date: moment(data?.publishedDate).format("YYYY-MM-DD"),
      estimated_date: moment(data?.estimatedDate).format("YYYY-MM-DD"),
      actual_date: moment(data?.actualDate).format("YYYY-MM-DD"),
      organization_name: data?.organization_name
        ? data?.organization_name
        : null,
      brief: data?.rma_Description ? data?.rma_Description : null,
      tracking_number: data?.trackingID ? data?.trackingID : null,
      shipping_method: data?.shipping_method ? data?.shipping_method : null,
      shipping_method_detail: data?.shipping_method_detail
        ? data?.shipping_method_detail
        : null,
      ko_detail: {
        name: data?.contractOfficerName ? data?.contractOfficerName : null,
        email: data?.contractOfficerEmail ? data?.contractOfficerEmail : null,
        phone: data?.contractOfficerPhone ? data?.contractOfficerPhone : null,
        address: data?.contractOfficerAddress
          ? data?.contractOfficerAddress
          : null,
      },
      shipping_detail: {
        name: data?.shippingCustomerName ? data?.shippingCustomerName : null,
        email: data?.shippingCustomerEmail ? data?.shippingCustomerEmail : null,
        phone: data?.shippingCustomerPhone ? data?.shippingCustomerPhone : null,
        address: data?.shippingCustomerAddress
          ? data?.shippingCustomerAddress
          : null,
      },
      // custom_fields: custom_fieldsTransformed,
      // products: [...transformedProducts],
      products: Array.isArray(transformedProducts)
        ? [...transformedProducts]
        : [],

      attachment_id: formId,
      total_cost_after_margin: data?.totalCostAfterMargin
        ? Number(data?.totalCostAfterMargin)
        : null,
    };

    const onSuccess = (res) => {
      const notesPayload = {
        module_id: res?.rma_id,
        module_type: "RMA",
        notes: data.notes,
      };

      if (Array.isArray(notesPayload.notes) && notesPayload.notes.length > 0) {
        createNotes(notesPayload);
      }
      setIsModalOpen({
        show: true,
        title: "RMA Created Successfully!",
        message: `Prepared by ${user?.username}. RMA ID is ${res.rma_id}.
         Created on ${moment(res?.created_date).format("MM/DD/YYYY")}.`,
        btntext: "Return Home",
      });
      reset();
    };

    const onSuccessUpdate = (res) => {
      const notesPayload = {
        module_id: res?.rma_id,
        module_type: "RMA",
        notes: data.notes,
      };

      if (Array.isArray(notesPayload.notes) && notesPayload.notes.length > 0) {
        createNotes(notesPayload);
      }
      setIsModalOpen({
        show: true,
        title: "RMA Updated Successfully!",
        message: `Updated by ${user?.username}. RMA ID is ${res.rma_id}.
        Created on ${moment(res?.created_date).format("MM/DD/YYYY")}.`,
        btntext: "Return Home",
      });
      reset();
    };

    if (rma && rma_id) {
      updateRMA(payload, onSuccessUpdate, onError);
    } else {
      createRMA(payload, onSuccess, onError, API_ENDPOINTS.CREATE_RMA);
    }
  };

  useEffect(() => {
    if (rma_id && !rmaDataFetched) {
      fetchSingleRma({ rma_id }, onSingleRmaSuccess);
      setRmaDataFetched(true);
      setIsEditing(true);
    } else {
      setInitialVal(0);
    }
  }, [rma_id, rmaDataFetched, fetchSingleRma]);

  useEffect(() => {
    if (rma_id && !rmaDataFetched) {
      fetchNotes(
        {
          module_id: rma_id,
          module_type: "RMA",
        },
        onSingleNotesSuccess,
      );
    }
  }, [rma_id, fetchNotes]);

  const handleOrderIDBlur = () => {
    const value = getValues("orderId");
    if (value.length > 0) {
      fetchDataByOrderID({ order_id: value }, onOrderIdSuccess, onOrderIdError);
    }
  };

  // useEffect(() => {
  //   if (rma && rma_id) {
  //     if (rma?.data?.attachment_id) {
  //       setFormId(rma?.data?.attachment_id);
  //     }
  //     setValue("orderId", rma?.data?.order_id ? rma?.data?.order_id : "");
  //     setValue(
  //       "opportunityName",
  //       rma?.data?.opportunity_name ? rma?.data?.opportunity_name : ""
  //     );
  //     setValue("rma_id", rma?.data?.rma_id ? rma?.data?.rma_id : null);
  //     setValue(
  //       "manufacturer_id",
  //       rma?.data?.manufacturer_id ? rma?.data?.manufacturer_id : null
  //     );
  //     setValue(
  //       "organization_name",
  //       rma?.data?.organization_name ? rma?.data?.organization_name : ""
  //     );
  //     setValue("rma_Description", rma?.data?.brief);
  //     setValue(
  //       "publishedDate",
  //       rma?.data?.published_date
  //         ? moment(rma?.data?.published_date).format("MM/DD/YYYY")
  //         : null
  //     );
  //     setValue(
  //       "estimatedDate",
  //       rma?.data?.estimated_date
  //         ? moment(rma?.data?.estimated_date).format("MM/DD/YYYY")
  //         : null
  //     );
  //     setValue(
  //       "actualDate",
  //       rma?.data?.actual_date
  //         ? moment(rma?.data?.actual_date).format("MM/DD/YYYY")
  //         : ""
  //     );
  //     setValue("Valid_For", rma?.data?.valid_for ? rma?.data?.valid_for : "");
  //     setValue(
  //       "estimateddelivery",
  //       rma?.data?.estimated_delivery ? rma?.data?.estimated_delivery : ""
  //     );
  //     setValue(
  //       "trackingID",
  //       rma?.data?.tracking_number ? rma?.data?.tracking_number : ""
  //     );
  //     setValue(
  //       "shipping_method",
  //       rma?.data?.shipping_method ? rma?.data?.shipping_method : ""
  //     );
  //     setValue(
  //       "shipping_method_detail",
  //       rma?.data?.shipping_method_detail
  //         ? rma?.data?.shipping_method_detail
  //         : ""
  //     );
  //     setValue(
  //       "contractOfficerName",
  //       rma?.data?.rmaKo?.name ? rma?.data?.rmaKo?.name : ""
  //     );
  //     setValue(
  //       "contractOfficerEmail",
  //       rma?.data?.rmaKo?.email ? rma?.data?.rmaKo?.email : ""
  //     );
  //     setValue(
  //       "contractOfficerPhone",
  //       rma?.data?.rmaKo?.phone ? rma?.data?.rmaKo?.phone : ""
  //     );
  //     setValue(
  //       "contractOfficerAddress",
  //       rma?.data?.rmaKo?.address ? rma?.data?.rmaKo?.address : ""
  //     );

  //     setValue(
  //       "shippingCustomerName",
  //       rma?.data?.rmaShipping?.name ? rma?.data?.rmaShipping?.name : ""
  //     );
  //     setValue(
  //       "shippingCustomerEmail",
  //       rma?.data?.rmaShipping?.email ? rma?.data?.rmaShipping?.email : ""
  //     );
  //     setValue(
  //       "shippingCustomerPhone",
  //       rma?.data?.rmaShipping?.phone ? rma?.data?.rmaShipping?.phone : ""
  //     );
  //     setValue(
  //       "shippingCustomerAddress",
  //       rma?.data?.rmaShipping?.address ? rma?.data?.rmaShipping?.address : ""
  //     );
  //   }
  // }, [rma, setValue]);

  const handleStepChange = (type) => {
    if (type === "next") {
      const currentData = methods.getValues();

      console.log(currentData);

      const fieldsToValidate = getFieldsForCurrentStep(currentStep);
      methods.trigger(fieldsToValidate).then((isValid) => {
        if (isValid) {
          setCurrentStep((prev) => prev + 1);
        } else {
          console.log("Errors:", methods.formState.errors);
        }
      });
    } else {
      console.log("Errors:2", methods.formState.errors);
      setCurrentStep((prev) => prev - 1);
    }
  };

  const handleTabChange = (tabIndex) => {
    if (rma_id) {
      const fieldsToValidate = getFieldsForCurrentStep(currentStep);

      methods.trigger(fieldsToValidate).then((isValid) => {
        if (isValid) {
          setCurrentStep(tabIndex);
        } else {
          console.log("Validation failed for step:", currentStep);
        }
      });
    }
  };

  useEffect(() => {
    if (!rma_id) {
      reset();
      setCurrentStep(1);
    } else {
    }
  }, [rma_id, location.pathname]);

  const getFieldsForCurrentStep = (step, rma_id) => {
    switch (step) {
      case 1:
        return [
          // "rma_id",
          // "manufacturer_id",
          // "organization_name",
          // "rma_Description",
          // "publishedDate",
          // "estimatedDate",
          // "actualDate",
          // "orderId",
          // "initialCause",
        ];
      case 2:
        return [
          // "shipping_method",
          // "shipping_method_detail",
          // "contractOfficerName",
          // "contractOfficerEmail",
          // "contractOfficerPhone",
          // "contractOfficerAddress",
          // "shippingCustomerName",
          // "shippingCustomerEmail",
          // "shippingCustomerPhone",
          // "shippingCustomerAddress",
        ];
      case 3:
        return ["products"];
      case 4:
        return [];
      case 5:
        return ["notes"];
      default:
        return [];
    }
  };

  useEffect(() => {
    const newFormId = generateUniqueId();
    setFormId(newFormId);
    reset();
  }, []);

  const rmaProductData = watch("products");

  console.log("the products are out ", singleRmaQuantity);
  console.log("rmaProductData", rmaProductData);

  if (rmaProductData) {
    console.log("the products are ", singleRmaQuantity);
    console.log("rmaProductData 2", rmaProductData);
  }

  return (
    <>
      <SuccsessMsgModal
        show={isModalOpen.show}
        onHide={() =>
          setIsModalOpen({ ...isModalOpen, show: false }, navigate("/list-rma"))
        }
        title={isModalOpen.title}
        btntext={isModalOpen.btntext}
        message={isModalOpen.message}
      />
      <div className="page-header d-none d-sm-block ">
        <div className=" d-flex justify-content-between  align-items-center">
          <div>
            <h2 className="page-title">
              {isEditing ? "Update RMA" : "Create RMA"}
            </h2>
          </div>
        </div>
      </div>

      <Card className="pt-3 pb-4 mt-5 mt-sm-0">
        <Card.Body>
          <div className="page-header d-block d-sm-none text-center">
            <h2 className="page-title justify-content-center">Create RMA</h2>
          </div>
          <FormProvider {...methods} className="">
            <Stepper
              steps={steps}
              currentStep={currentStep}
              onTabClick={rma_id ? handleTabChange : undefined}
            />
            {currentStep === 1 && <CreateRma />}
            {currentStep === 2 && <InvestigationForm rmaData={rmaSuccess} />}
            {currentStep === 3 && <ResolutionForm singleRma={rmaSuccess} />}
            {currentStep === 4 && <FollowupForm singleRmaData={rmaSuccess} />}
            {currentStep === 5 && (
              <FileUpload moduleType={"RMA"} attachmnetid={formId} />
            )}
            {currentStep === 6 && <NotesSection />}

            <div className="server_error">
              {show && (
                <>
                  <Alert
                    variant="danger"
                    onClose={() => setShow(false)}
                    dismissible
                  >
                    <Alert.Heading>Validation Errors!</Alert.Heading>
                    {Object.keys(serverErr).map((field) => (
                      <p
                        key={field}
                        style={{ color: "red", marginBottom: "5px" }}
                      >
                        {serverErr[field]?.message}
                      </p>
                    ))}
                  </Alert>
                </>
              )}
            </div>

            <div className="d-flex justify-content-center gap-3 mt-3">
              {/* {currentStep > 1 && (
                <Button
                  variant="outline-secondary"
                  onClick={() => handleStepChange("prev")}
                >
                  <IconArrowNarrowLeftDashed /> Back
                </Button>
              )}
              {currentStep >= 2 && currentStep < 6 && (
                <Button
                  variant="warning"
                  onClick={() => handleStepChange("next")}
                >
                  Next <IconArrowNarrowRightDashed />
                </Button>
              )} */}
              {/* {rma_id
                  ? currentStep < steps.length && (
                      <div className="d-flex">
                        <Button variant="primary" type="submit">
                          {createLoading || UpdateLoading ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Update"
                          )}
                        </Button>
                      </div>
                    )
                  : null} */}
              {/* {currentStep === 6 && (
                <div className="d-flex">
                  <Button variant="warning" type="submit">
                    {createLoading || UpdateLoading ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </div>
              )} */}
            </div>
          </FormProvider>
        </Card.Body>
      </Card>
    </>
  );
}

export default UpdateRma;
